import React from 'react';

import "../src/css/anchor_tabs.css";

import certBasic from '../src/imgs/lateral_sections/certificacion_basica.svg';
import certIntermedia from '../src/imgs/lateral_sections/certificacion_intermedia.svg';
import certAvanzada from '../src/imgs/lateral_sections/certificacion_avanzada.svg';

export const AnchorTabsCategories = () => {
    const pathArray = window.location.pathname.split("/");
    const peten = "peten";
    
    const delegacionCentral = "/app/";
    const delegacionPeten = "/peten/";
    
    const delegacion = pathArray.includes(peten) ? (delegacionPeten) : (delegacionCentral);

  return (

    <>
        <div className="menu_vinetas_cats">

            <a className="vineta tab_anchor_cat1" href={`${delegacion}asesorias`}>
                <img src={certBasic} alt="Certificación Básica" />
                <p>Investigación, Asesoría y Asistencia Técnica</p>
            </a>
            
            <a className="vineta tab_anchor_cat2" href={`${delegacion}Certificaciones`}>
                <img src={certIntermedia} alt="Certificación Básica" />
                <p>Certificaciones</p>
            </a>
            
            <a className="vineta tab_anchor_cat3" href={`${delegacion}cursos`}>
                <img src={certAvanzada} alt="Certificación Básica" />
                <p>Cursos y Diplomados</p>
            </a>

            <a className="vineta tab_anchor_cat4" href={`${delegacion}posgrados`}>
                <img src={certAvanzada} alt="Certificación Básica" />
                <p>Estudios de Posgrados</p>
            </a>

        </div>
    
    </>


  )
}